import { h$1 as B, h$2 as z, h as M, me as Ct } from "./register-Ba9sFUKZ.js";
import { A as Nt } from "./passthroughAttributes-C4XaYcZ0.js";
import { r as Ft } from "./cta-variant-Cf2MRz8Z.js";
import { v as Lt } from "./mixin-CP6jLr_x.js";
import { T as Vt } from "./tracks-default-slot-BZiX8u6R.js";
import { A as ft, q as U } from "./query-assigned-DFc_RnLg.js";
import { h as Dt } from "./lifecycle-decorators-C04d1yHY.js";
(function() {
  (function(a) {
    const l = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap(), q = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), G = /* @__PURE__ */ new WeakMap(), X = /* @__PURE__ */ new WeakMap(), K = /* @__PURE__ */ new WeakMap(), Y = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), O = {
      ariaAtomic: "aria-atomic",
      ariaAutoComplete: "aria-autocomplete",
      ariaBusy: "aria-busy",
      ariaChecked: "aria-checked",
      ariaColCount: "aria-colcount",
      ariaColIndex: "aria-colindex",
      ariaColIndexText: "aria-colindextext",
      ariaColSpan: "aria-colspan",
      ariaCurrent: "aria-current",
      ariaDescription: "aria-description",
      ariaDisabled: "aria-disabled",
      ariaExpanded: "aria-expanded",
      ariaHasPopup: "aria-haspopup",
      ariaHidden: "aria-hidden",
      ariaInvalid: "aria-invalid",
      ariaKeyShortcuts: "aria-keyshortcuts",
      ariaLabel: "aria-label",
      ariaLevel: "aria-level",
      ariaLive: "aria-live",
      ariaModal: "aria-modal",
      ariaMultiLine: "aria-multiline",
      ariaMultiSelectable: "aria-multiselectable",
      ariaOrientation: "aria-orientation",
      ariaPlaceholder: "aria-placeholder",
      ariaPosInSet: "aria-posinset",
      ariaPressed: "aria-pressed",
      ariaReadOnly: "aria-readonly",
      ariaRelevant: "aria-relevant",
      ariaRequired: "aria-required",
      ariaRoleDescription: "aria-roledescription",
      ariaRowCount: "aria-rowcount",
      ariaRowIndex: "aria-rowindex",
      ariaRowIndexText: "aria-rowindextext",
      ariaRowSpan: "aria-rowspan",
      ariaSelected: "aria-selected",
      ariaSetSize: "aria-setsize",
      ariaSort: "aria-sort",
      ariaValueMax: "aria-valuemax",
      ariaValueMin: "aria-valuemin",
      ariaValueNow: "aria-valuenow",
      ariaValueText: "aria-valuetext",
      role: "role"
    }, ht = (e, t) => {
      for (let o in O) {
        t[o] = null;
        let n = null;
        const i = O[o];
        Object.defineProperty(t, o, {
          get() {
            return n;
          },
          set(r) {
            n = r, e.isConnected ? v(e, i, r) : S.set(e, t);
          }
        });
      }
    };
    function J(e) {
      const t = c.get(e), { form: o } = t;
      nt(e, o, t), ot(e, t.labels);
    }
    const Q = (e, t = !1) => {
      const o = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
        acceptNode(r) {
          return c.has(r) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      let n = o.nextNode();
      const i = !t || e.disabled;
      for (; n; )
        n.formDisabledCallback && i && $(n, e.disabled), n = o.nextNode();
    }, Z = { attributes: !0, attributeFilter: ["disabled", "name"] }, C = L() ? new MutationObserver((e) => {
      for (const t of e) {
        const o = t.target;
        if (t.attributeName === "disabled" && (o.constructor.formAssociated ? $(o, o.hasAttribute("disabled")) : o.localName === "fieldset" && Q(o)), t.attributeName === "name" && o.constructor.formAssociated) {
          const n = c.get(o), i = q.get(o);
          n.setFormValue(i);
        }
      }
    }) : {};
    function R(e) {
      e.forEach((t) => {
        const { addedNodes: o, removedNodes: n } = t, i = Array.from(o), r = Array.from(n);
        i.forEach((s) => {
          var f;
          if (c.has(s) && s.constructor.formAssociated && J(s), S.has(s)) {
            const d = S.get(s);
            Object.keys(O).filter((m) => d[m] !== null).forEach((m) => {
              v(s, O[m], d[m]);
            }), S.delete(s);
          }
          if (A.has(s)) {
            const d = A.get(s);
            v(s, "internals-valid", d.validity.valid.toString()), v(s, "internals-invalid", (!d.validity.valid).toString()), v(s, "aria-invalid", (!d.validity.valid).toString()), A.delete(s);
          }
          if (s.localName === "form") {
            const d = y.get(s), m = document.createTreeWalker(s, NodeFilter.SHOW_ELEMENT, {
              acceptNode(j) {
                return c.has(j) && j.constructor.formAssociated && !(d && d.has(j)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
            let I = m.nextNode();
            for (; I; )
              J(I), I = m.nextNode();
          }
          s.localName === "fieldset" && ((f = C.observe) === null || f === void 0 || f.call(C, s, Z), Q(s, !0));
        }), r.forEach((s) => {
          const f = c.get(s);
          f && w.get(f) && tt(f), D.has(s) && D.get(s).disconnect();
        });
      });
    }
    function pt(e) {
      e.forEach((t) => {
        const { removedNodes: o } = t;
        o.forEach((n) => {
          const i = K.get(t.target);
          c.has(n) && it(n), i.disconnect();
        });
      });
    }
    const bt = (e) => {
      var t, o;
      const n = new MutationObserver(pt);
      !((t = window == null ? void 0 : window.ShadyDOM) === null || t === void 0) && t.inUse && e.mode && e.host && (e = e.host), (o = n.observe) === null || o === void 0 || o.call(n, e, { childList: !0 }), K.set(e, n);
    };
    L() && new MutationObserver(R);
    const P = {
      childList: !0,
      subtree: !0
    }, v = (e, t, o) => {
      e.getAttribute(t) !== o && e.setAttribute(t, o);
    }, $ = (e, t) => {
      e.toggleAttribute("internals-disabled", t), t ? v(e, "aria-disabled", "true") : e.removeAttribute("aria-disabled"), e.formDisabledCallback && e.formDisabledCallback.apply(e, [t]);
    }, tt = (e) => {
      w.get(e).forEach((t) => {
        t.remove();
      }), w.set(e, []);
    }, et = (e, t) => {
      const o = document.createElement("input");
      return o.type = "hidden", o.name = e.getAttribute("name"), e.after(o), w.get(t).push(o), o;
    }, gt = (e, t) => {
      var o;
      w.set(t, []), (o = C.observe) === null || o === void 0 || o.call(C, e, Z);
    }, ot = (e, t) => {
      if (t.length) {
        Array.from(t).forEach((n) => n.addEventListener("click", e.click.bind(e)));
        let o = t[0].id;
        t[0].id || (o = `${t[0].htmlFor}_Label`, t[0].id = o), v(e, "aria-labelledby", o);
      }
    }, N = (e) => {
      const t = Array.from(e.elements).filter((r) => !r.tagName.includes("-") && r.validity).map((r) => r.validity.valid), o = y.get(e) || [], n = Array.from(o).filter((r) => r.isConnected).map((r) => c.get(r).validity.valid), i = [...t, ...n].includes(!1);
      e.toggleAttribute("internals-invalid", i), e.toggleAttribute("internals-valid", !i);
    }, yt = (e) => {
      N(F(e.target));
    }, vt = (e) => {
      N(F(e.target));
    }, wt = (e) => {
      const t = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((o) => `${o}:not([disabled])`).map((o) => `${o}:not([form])${e.id ? `,${o}[form='${e.id}']` : ""}`).join(",");
      e.addEventListener("click", (o) => {
        if (o.target.closest(t)) {
          const n = y.get(e);
          if (e.noValidate)
            return;
          n.size && Array.from(n).reverse().map((i) => c.get(i).reportValidity()).includes(!1) && o.preventDefault();
        }
      });
    }, Et = (e) => {
      const t = y.get(e.target);
      t && t.size && t.forEach((o) => {
        o.constructor.formAssociated && o.formResetCallback && o.formResetCallback.apply(o);
      });
    }, nt = (e, t, o) => {
      if (t) {
        const n = y.get(t);
        if (n)
          n.add(e);
        else {
          const i = /* @__PURE__ */ new Set();
          i.add(e), y.set(t, i), wt(t), t.addEventListener("reset", Et), t.addEventListener("input", yt), t.addEventListener("change", vt);
        }
        E.set(t, { ref: e, internals: o }), e.constructor.formAssociated && e.formAssociatedCallback && setTimeout(() => {
          e.formAssociatedCallback.apply(e, [t]);
        }, 0), N(t);
      }
    }, F = (e) => {
      let t = e.parentNode;
      return t && t.tagName !== "FORM" && (t = F(t)), t;
    }, g = (e, t, o = DOMException) => {
      if (!e.constructor.formAssociated)
        throw new o(t);
    }, at = (e, t, o) => {
      const n = y.get(e);
      return n && n.size && n.forEach((i) => {
        c.get(i)[o]() || (t = !1);
      }), t;
    }, it = (e) => {
      if (e.constructor.formAssociated) {
        const t = c.get(e), { labels: o, form: n } = t;
        ot(e, o), nt(e, n, t);
      }
    };
    function L() {
      return typeof MutationObserver < "u";
    }
    class Mt {
      constructor() {
        this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
      }
    }
    const xt = (e) => (e.badInput = !1, e.customError = !1, e.patternMismatch = !1, e.rangeOverflow = !1, e.rangeUnderflow = !1, e.stepMismatch = !1, e.tooLong = !1, e.tooShort = !1, e.typeMismatch = !1, e.valid = !0, e.valueMissing = !1, e), Tt = (e, t, o) => (e.valid = It(t), Object.keys(t).forEach((n) => e[n] = t[n]), o && N(o), e), It = (e) => {
      let t = !0;
      for (let o in e)
        o !== "valid" && e[o] !== !1 && (t = !1);
      return t;
    }, H = /* @__PURE__ */ new WeakMap();
    function rt(e, t) {
      e.toggleAttribute(t, !0), e.part && e.part.add(t);
    }
    class W extends Set {
      static get isPolyfilled() {
        return !0;
      }
      constructor(t) {
        if (super(), !t || !t.tagName || t.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        H.set(this, t);
      }
      add(t) {
        if (!/^--/.test(t) || typeof t != "string")
          throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${t} must start with '--'.`);
        const o = super.add(t), n = H.get(this), i = `state${t}`;
        return n.isConnected ? rt(n, i) : setTimeout(() => {
          rt(n, i);
        }), o;
      }
      clear() {
        for (let [t] of this.entries())
          this.delete(t);
        super.clear();
      }
      delete(t) {
        const o = super.delete(t), n = H.get(this);
        return n.isConnected ? (n.toggleAttribute(`state${t}`, !1), n.part && n.part.remove(`state${t}`)) : setTimeout(() => {
          n.toggleAttribute(`state${t}`, !1), n.part && n.part.remove(`state${t}`);
        }), o;
      }
    }
    function st(e, t, o, n) {
      if (o === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
      if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return o === "m" ? n : o === "a" ? n.call(e) : n ? n.value : t.get(e);
    }
    function kt(e, t, o, n, i) {
      if (typeof t == "function" ? e !== t || !0 : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return t.set(e, o), o;
    }
    var T;
    class St {
      constructor(t) {
        T.set(this, void 0), kt(this, T, t);
        for (let o = 0; o < t.length; o++) {
          let n = t[o];
          this[o] = n, n.hasAttribute("name") && (this[n.getAttribute("name")] = n);
        }
        Object.freeze(this);
      }
      get length() {
        return st(this, T, "f").length;
      }
      [(T = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
        return st(this, T, "f")[Symbol.iterator]();
      }
      item(t) {
        return this[t] == null ? null : this[t];
      }
      namedItem(t) {
        return this[t] == null ? null : this[t];
      }
    }
    function At() {
      const e = HTMLFormElement.prototype.checkValidity;
      HTMLFormElement.prototype.checkValidity = o;
      const t = HTMLFormElement.prototype.reportValidity;
      HTMLFormElement.prototype.reportValidity = n;
      function o(...r) {
        let s = e.apply(this, r);
        return at(this, s, "checkValidity");
      }
      function n(...r) {
        let s = t.apply(this, r);
        return at(this, s, "reportValidity");
      }
      const { get: i } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
      Object.defineProperty(HTMLFormElement.prototype, "elements", {
        get(...r) {
          const s = i.call(this, ...r), f = Array.from(y.get(this) || []);
          if (f.length === 0)
            return s;
          const d = Array.from(s).concat(f).sort((m, I) => m.compareDocumentPosition ? m.compareDocumentPosition(I) & 2 ? 1 : -1 : 0);
          return new St(d);
        }
      });
    }
    class lt {
      static get isPolyfilled() {
        return !0;
      }
      constructor(t) {
        if (!t || !t.tagName || t.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        const o = t.getRootNode(), n = new Mt();
        this.states = new W(t), l.set(this, t), u.set(this, n), c.set(t, this), ht(t, this), gt(t, this), Object.seal(this), o instanceof DocumentFragment && bt(o);
      }
      checkValidity() {
        const t = l.get(this);
        if (g(t, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const o = u.get(this);
        if (!o.valid) {
          const n = new Event("invalid", {
            bubbles: !1,
            cancelable: !0,
            composed: !1
          });
          t.dispatchEvent(n);
        }
        return o.valid;
      }
      get form() {
        const t = l.get(this);
        g(t, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
        let o;
        return t.constructor.formAssociated === !0 && (o = F(t)), o;
      }
      get labels() {
        const t = l.get(this);
        g(t, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
        const o = t.getAttribute("id"), n = t.getRootNode();
        return n && o ? n.querySelectorAll(`[for="${o}"]`) : [];
      }
      reportValidity() {
        const t = l.get(this);
        if (g(t, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const o = this.checkValidity(), n = X.get(this);
        if (n && !t.constructor.formAssociated)
          throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
        return !o && n && (t.focus(), n.focus()), o;
      }
      setFormValue(t) {
        const o = l.get(this);
        if (g(o, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), tt(this), t != null && !(t instanceof FormData)) {
          if (o.getAttribute("name")) {
            const n = et(o, this);
            n.value = t;
          }
        } else t != null && t instanceof FormData && Array.from(t).reverse().forEach(([n, i]) => {
          if (typeof i == "string") {
            const r = et(o, this);
            r.name = n, r.value = i;
          }
        });
        q.set(o, t);
      }
      setValidity(t, o, n) {
        const i = l.get(this);
        if (g(i, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !t)
          throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
        X.set(this, n);
        const r = u.get(this), s = {};
        for (const m in t)
          s[m] = t[m];
        Object.keys(s).length === 0 && xt(r);
        const f = Object.assign(Object.assign({}, r), s);
        delete f.valid;
        const { valid: d } = Tt(r, f, this.form);
        if (!d && !o)
          throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
        b.set(this, d ? "" : o), i.isConnected ? (i.toggleAttribute("internals-invalid", !d), i.toggleAttribute("internals-valid", d), v(i, "aria-invalid", `${!d}`)) : A.set(i, this);
      }
      get shadowRoot() {
        const t = l.get(this);
        return G.get(t) || null;
      }
      get validationMessage() {
        const t = l.get(this);
        return g(t, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), b.get(this);
      }
      get validity() {
        const t = l.get(this);
        return g(t, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), u.get(this);
      }
      get willValidate() {
        const t = l.get(this);
        return g(t, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(t.disabled || t.hasAttribute("disabled") || t.hasAttribute("readonly"));
      }
    }
    function Ot() {
      if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
        return !1;
      class e extends HTMLElement {
        constructor() {
          super(), this.internals = this.attachInternals();
        }
      }
      const t = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
      customElements.define(t, e);
      const o = new e();
      return [
        "shadowRoot",
        "form",
        "willValidate",
        "validity",
        "validationMessage",
        "labels",
        "setFormValue",
        "setValidity",
        "checkValidity",
        "reportValidity"
      ].every((n) => n in o.internals);
    }
    let ct = !1, dt = !1;
    function _(e) {
      dt || (dt = !0, window.CustomStateSet = W, e && (HTMLElement.prototype.attachInternals = function(...t) {
        const o = e.call(this, t);
        return o.states = new W(this), o;
      }));
    }
    function ut(e = !0) {
      if (!ct) {
        if (ct = !0, typeof window < "u" && (window.ElementInternals = lt), typeof CustomElementRegistry < "u") {
          const t = CustomElementRegistry.prototype.define;
          CustomElementRegistry.prototype.define = function(o, n, i) {
            if (n.formAssociated) {
              const r = n.prototype.connectedCallback;
              n.prototype.connectedCallback = function() {
                Y.has(this) || (Y.set(this, !0), this.hasAttribute("disabled") && $(this, !0)), r != null && r.apply(this), it(this);
              };
            }
            t.call(this, o, n, i);
          };
        }
        if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
          if (this.tagName) {
            if (this.tagName.indexOf("-") === -1)
              throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
          } else return {};
          if (c.has(this))
            throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
          return new lt(this);
        }), typeof Element < "u") {
          let t = function(...n) {
            const i = o.apply(this, n);
            if (G.set(this, i), L()) {
              const r = new MutationObserver(R);
              window.ShadyDOM ? r.observe(this, P) : r.observe(i, P), D.set(this, r);
            }
            return i;
          };
          const o = Element.prototype.attachShadow;
          Element.prototype.attachShadow = t;
        }
        L() && typeof document < "u" && new MutationObserver(R).observe(document.documentElement, P), typeof HTMLFormElement < "u" && At(), (e || typeof window < "u" && !window.CustomStateSet) && _();
      }
    }
    return customElements.polyfillWrapFlushCallback || (Ot() ? typeof window < "u" && !window.CustomStateSet && _(HTMLElement.prototype.attachInternals) : ut(!1)), a.forceCustomStateSetPolyfill = _, a.forceElementInternalsPolyfill = ut, Object.defineProperty(a, "__esModule", { value: !0 }), a;
  })({});
})();
var mt = /* @__PURE__ */ ((a) => (a.LOADING = "loading", a.PROGRESS = "progress", a.SUCCESS = "success", a.RESULT = "result", a.NONE = "", a))(mt || {}), V = /* @__PURE__ */ ((a) => (a.SUBMIT = "submit", a.BUTTON = "button", a.RESET = "reset", a.MENU = "menu", a))(V || {});
const Rt = B`.beacon-button-icon{align-self:var(--beacon-button-icon-align, center);block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5)}.beacon-button-icon .beacon-button-icon--icon{fill:currentcolor}.beacon-button-icon .beacon-button-icon--stroke{stroke:currentcolor}.close-button-wrapper .beacon-button-icon{block-size:unset;inline-size:unset}[beacon-tag-name=beacon-icon-button] .beacon-button-icon{block-size:var(--override-icon-button-block-size, var(--beacon-reference-space-7));inline-size:var(--override-icon-button-inline-size, var(--beacon-reference-space-7))}`, Pt = B`:host([motion-state=enabled]) a,:host([motion-state=enabled]) button,:host([motion-state=enabled]) .icon-button{--button-base-transition-property: background-color;transition-duration:var(--button-base-transition-duration, 0s);transition-property:var(--button-base-transition-property);transition-timing-function:var(--button-base-transition-timing-function, var(--beacon-system-motion-easing-decelerate-emphasize-1))}:host([motion-state=enabled]) a .contents,:host([motion-state=enabled]) button .contents,:host([motion-state=enabled]) .icon-button .contents{transition-duration:inherit;transition-property:transform;transition-timing-function:inherit}`;
var $t = (a, l, u, w) => {
  for (var c = l, b = a.length - 1, E; b >= 0; b--)
    (E = a[b]) && (c = E(c) || c);
  return c;
};
function Ht(a) {
  let l = class extends a {
    static get ButtonBaseMotionStyles() {
      return [Pt];
    }
  };
  return l = $t([
    Dt("ButtonBaseMotion")
  ], l), l;
}
const Wt = B`:host(:not(.skip-focus-override)) :is(button,a):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}:host(:not(.skip-focus-override)) :is(button,a).tertiary:focus-visible{--second-ring-width: calc(var(--beacon-system-width-border-jumbo) + var(--beacon-system-width-border-normal));box-shadow:0 0 0 var(--second-ring-width) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:0;position:relative;z-index:1}`;
var _t = Object.defineProperty, p = (a, l, u, w) => {
  for (var c = void 0, b = a.length - 1, E; b >= 0; b--)
    (E = a[b]) && (c = E(l, u, c) || c);
  return c && _t(l, u, c), c;
};
const k = {
  icon: "beacon-button-icon",
  strokeFill: "beacon-button-icon--stroke",
  iconFill: "beacon-button-icon--icon"
}, jt = "stroke";
var x;
const h = (x = class extends Lt(Ct).with(
  Ht,
  Vt({ clean: !0 })
) {
  constructor() {
    super(), this._passthroughs = new Nt(this), this.focusOverride = !0, this.SLOTTED_ICON_INDEX = 0, this.type = V.BUTTON, this.variant = Ft.PRIMARY, this.state = mt.NONE, this.disabled = !1, this.linkHref = "", this.internals = this.attachInternals ? this.attachInternals() : null;
  }
  static get styles() {
    return [super.styles, Wt, this.ButtonBaseMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, Rt];
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(a, l, u = this.formAnchor) {
    this.internals && this.internals.setValidity(a, l, u);
  }
  get prefixIcon() {
    return this.prefixIconElements[this.SLOTTED_ICON_INDEX];
  }
  get suffixIcon() {
    return this.suffixIconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Returns the first element in the icon slot
   */
  get icon() {
    return this.iconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Event listener for internal HTML button that
   * determines click behavior depending on its disabled state
   * and button type.
   * @param event click event
   * @event {BeaconEvents} beacon-event-click - Emits when clicked
   */
  handleClick(a) {
    if (this.disabled)
      a.preventDefault(), a.stopPropagation(), a.stopImmediatePropagation();
    else if (this.emitClick(), this.internals)
      switch (this.type) {
        case V.SUBMIT:
          this.internals.form.requestSubmit();
          break;
        case V.RESET:
          this.internals.form.reset();
          break;
      }
  }
  /**
   * Applies proper CSS class to slotted SVG such that it renders correctly
   * @param element reference to the slotted SVG
   */
  static applySVGClass(a) {
    a && Array.from(a.children).forEach((l) => {
      if (l) {
        const u = l.getAttribute(jt) ? k.strokeFill : k.iconFill;
        l.classList.add(u);
      }
    });
  }
  handleIconSlotchange() {
    if (this.iconElements.length > 0)
      for (const a of this.iconElements) {
        a.classList.add(k.icon);
        const l = this.defaultSlotText;
        z(a, l), x.applySVGClass(a);
      }
  }
  handleAffixSlotChanges({ target: a }) {
    if (a instanceof HTMLSlotElement) {
      const l = a.name;
      if (l === "suffix" && this.suffixIcon) {
        this.suffixIcon.classList.add(k.icon);
        const u = this.defaultSlotText;
        z(this.suffixIcon, u), x.applySVGClass(this.suffixIcon);
      } else if (l === "prefix" && this.prefixIcon) {
        this.prefixIcon.classList.add(k.icon);
        const u = this.defaultSlotText;
        z(this.prefixIcon, u), x.applySVGClass(this.prefixIcon);
      }
    }
  }
}, x.formAssociated = !0, x);
p([
  ft(".form-anchor")
], h.prototype, "formAnchor");
p([
  M({ reflect: !0 })
], h.prototype, "type");
p([
  M()
], h.prototype, "variant");
p([
  M()
], h.prototype, "state");
p([
  M({ type: Boolean })
], h.prototype, "disabled");
p([
  M({ attribute: "link-href" })
], h.prototype, "linkHref");
p([
  M({ attribute: "link-download" })
], h.prototype, "linkDownload");
p([
  M({ attribute: "link-target" })
], h.prototype, "linkTarget");
p([
  U({ flatten: !0, slot: "icon", selector: "svg" })
], h.prototype, "iconElements");
p([
  U({
    flatten: !0,
    slot: "prefix",
    selector: "svg"
  })
], h.prototype, "prefixIconElements");
p([
  U({
    flatten: !0,
    slot: "suffix",
    selector: "svg"
  })
], h.prototype, "suffixIconElements");
p([
  ft("button, a")
], h.prototype, "button");
let Yt = h;
export {
  Yt as X,
  mt as s
};
